import { watchImmediate } from '@vueuse/core';
import { type Ref, onUnmounted } from 'vue';

import { createInjectionStateOrThrow } from '@abaninja/utils';

import { usePageLoaderContext } from './PageLoader.use';

export const [providePageLoader, injectPageLoaderOrThrow] = createInjectionStateOrThrow('PageLoader', usePageLoaderContext);

export const usePageLoader = (isLoading: Ref<boolean>) => {
  const pageLoader = injectPageLoaderOrThrow();

  const id = Symbol('pageLoader');

  watchImmediate(isLoading, (value) => {
    if (value) {
      pageLoader.setItem(id, true);
    } else {
      pageLoader.deleteItem(id);
    }
  });

  onUnmounted(() => {
    pageLoader.deleteItem(id);
  });
};
